module.exports = __webpack_public_path__ + "img/17875_S.8ad76acd.png";